import { ExclamationCircleIcon } from '@heroicons/react/20/solid';
import { InputHTMLAttributes, ReactElement } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '../../atoms';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  id: string;
  name: string;
  errorName: string;
  label: string;
  isDisabled?: boolean;
}
export const CheckBoxForm = ({
  id,
  name,
  errorName,
  label,
  isDisabled = false,
}: Props): ReactElement => {
  const { control } = useFormContext();
  const {
    field: { value, onChange },
    formState: { errors },
  } = useController({ control, name });

  const { t } = useTranslation('errors');
  const error = errors?.[errorName]?.message ?? '';
  const errorTranslated = t(error as string);

  return (
    <div className="flex items-center space-x-2">
      <Checkbox
        id={id}
        name={name}
        disabled={isDisabled}
        checked={value}
        onCheckedChange={(isChecked) => onChange(isChecked)}
      />
      <label
        htmlFor={id}
        className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 dark:text-white"
      >
        {label}
      </label>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
        {errorTranslated ? (
          <ExclamationCircleIcon
            className="h-5 w-5 text-red-500"
            aria-hidden="true"
          />
        ) : (
          <span className="h-5 w-5 " />
        )}
      </div>
    </div>
  );
};

export default CheckBoxForm;
